import { LuZap } from "react-icons/lu";
import { Box } from "@mui/material";

const AIEnergyIcon = ({ 
  size = "medium", 
  animate = true,
  isRotating = false,
  className = "ai-energy-icon",
  iconColor 
}) => {
  const sizeMap = {
    small: "1rem",
    medium: "1.3rem",
    large: "1.6rem",
    xlarge: "2rem"
  };

  const iconStyles = {
    fontSize: sizeMap[size] || sizeMap.medium,
    color: iconColor ? iconColor : "hsl(var(--primary-foreground))",
    margin: 0,
    position: "relative",
    zIndex: 1,
    transition: isRotating 
      ? "none" 
      : "all 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55)",
    animation: animate ? "ai-icon-float 4s ease-in-out infinite" : "none",
    transform: isRotating ? "scale(1.1)" : "scale(1)",
    filter: isRotating 
      ? `drop-shadow(0 0 5px hsl(var(--cyan))) drop-shadow(0 0 10px hsl(var(--emerald) / 0.7))`
      : `drop-shadow(0 0 2px hsl(var(--cyan) / 0.5))`,
  };

  return (
    <Box 
      className={className}
      sx={{
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transformStyle: "preserve-3d",
      }}
    >
      <LuZap style={iconStyles} />
      
      {/* Subtle glow behind icon during rotation */}
      {isRotating && (
        <Box
          sx={{
            position: "absolute",
            width: "140%",
            height: "140%",
            background: `radial-gradient(
              ellipse at center,
              hsl(var(--cyan) / 0.4) 0%,
              transparent 70%
            )`,
            borderRadius: "50%",
            zIndex: 0,
            animation: "glow-pulse-fast 0.6s ease-in-out",
          }}
        />
      )}
    </Box>
  );
};

export default AIEnergyIcon;